var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EBillType } from "../../../enum/EBillType";
import { toDetail } from "../../../helper/util";
var DeliveryDialog = (function (_super) {
    __extends(DeliveryDialog, _super);
    function DeliveryDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalShow = false;
        _this.modalTitle = '选择送货单';
        _this.list = [];
        _this.eBillType = EBillType;
        return _this;
    }
    DeliveryDialog.prototype.toPage = function (type, id) {
        this.close();
        toDetail(type, id);
    };
    DeliveryDialog.prototype.delivery = function (row) {
        this.close();
        this.$emit("toShip", row);
    };
    DeliveryDialog.prototype.close = function () {
        this.modalShow = false;
    };
    DeliveryDialog.prototype.show = function (title, list) {
        this.modalTitle = title;
        this.list = list;
        this.modalShow = true;
    };
    DeliveryDialog = __decorate([
        Component
    ], DeliveryDialog);
    return DeliveryDialog;
}(Vue));
export default DeliveryDialog;
